import _ from 'lodash';
import {
  FETCH_ALL_CAMPAIGN_SUCCEED,
  ADD_CAMPAIGN_SUCCEED,
  UPDATE_CAMPAIGN_SUCCEED,
  DELETE_CAMPAIGN_SUCCEED,
} from '../actions/campaign/action_types';

export default (
  state = {
    campaign: [],
  }, action,
) => {
  switch (action.type) {
    case FETCH_ALL_CAMPAIGN_SUCCEED:

      const newArr = action.params.data;
      _.forEach(newArr, (value, index) => {
        value.newPanes = [];
        let i = _.size(value.title);
        _.forEach(value.title, (item, key) => {
          value.newPanes = [
            ...value.newPanes,
            {
              title: key,
              key: `${i}`,
              closable: (!(key === 'VI' || key === 'EN')),
            },
          ];
          i--;
        });
        _.reverse(value.newPanes);
      });

      return {
        ...state,
        campaign: newArr,
      };
    case ADD_CAMPAIGN_SUCCEED:
      return {
        ...state,
      };
    case UPDATE_CAMPAIGN_SUCCEED:
      return {
        ...state,
      };
    case DELETE_CAMPAIGN_SUCCEED:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};
